<template>
	<section class="cta">
		<div class="cta__content">
			<h2 class="generic__subheading">{{ locale === 'en' ? 'Interested in working with us?' : '私たちと一緒にお仕事をしませんか？' }}</h2>
			<nuxt-link :to="localePath('/contact')" class="button cta__button">
				{{ locale === 'en' ? 'Get in touch!' : 'お問い合わせ' }}
			</nuxt-link>
		</div>
	</section>
</template>

<script setup>
import { useI18n, useLocalePath } from '#imports'
import { computed } from 'vue'
const { locale } = useI18n()
const localePath = useLocalePath()
</script>

<style lang="scss" scoped>
	@use '@/assets/sass/variables.scss' as v;
	.cta {
		margin: 1rem;
		@include v.respond-to('small') {
			margin: 3rem;
		}
		&__content {
			background-color: v.$paleGrey;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin: 0 auto;
			max-width: 60rem;
			padding: 6rem 0;
		}
	}
</style>
